import React from 'react';
import '../styles/GrainOverlay.css';

const GrainOverlay: React.FC = () => <div className="grain-overlay" aria-hidden="true" />;

export default GrainOverlay;
